import { FeatureFlags } from '@api-types/types/feature-flags';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const FeatureFlagActions = createActionGroup({
  source: 'FeatureFlags',
  events: {
    'Set All Feature Flags': props<{ featureFlags: FeatureFlags }>(),
    'Get All Feature Flags': emptyProps(),
  },
});
